import { Field, FieldError, FieldLabel } from '@/components'
import { cn } from '@/lib/utils'
import type { PropsWithChildren, ReactNode } from 'react'

interface ExportFieldProps extends PropsWithChildren {
  className?: string

  label: ReactNode
  labelRight?: ReactNode
  error?: string | null
  wide?: boolean
}

export const ExportField: React.FC<ExportFieldProps> = ({
  children,
  className,

  label,
  labelRight,
  error,
  wide = false,
}) => (
  <Field className={cn('min-w-0 gap-2', wide && 'md:col-span-2', className)}>
    <div className="flex min-h-7 items-center justify-between gap-2">
      <FieldLabel className="text-xs font-semibold uppercase text-stone-500">
        {label}
      </FieldLabel>
      {labelRight}
    </div>

    {children}

    {!!error && <FieldError>{error}</FieldError>}
  </Field>
)
